<script setup>
import '@/styles/css/blog-page.scss'
import '@/styles/css/blog-post-card.scss'
import { onMounted } from 'vue';
onMounted(()=>{
  $('.container.market-talk-cat.market-talk-cat-web.hidden-sm.hidden-xs').click(()=>{
    return false;
  })
})
</script>
<template>
  <div class="page-container">
    <section class="blog-banner banner-inner">
      <div class="container !block">
        <div class="blog-intro">
          <p
            class="wow fadeInUp animated"
            data-wow-duration="1s"
            style="visibility: visible; animation-duration: 1s"
          >
            UPSTOX BLOG
          </p>
          <h1
            class="wow fadeInDown animated"
            data-wow-duration="1s"
            style="visibility: visible; animation-duration: 1s"
          >
            Market Talk
          </h1>
        </div>
        <ul
          class="container market-talk-cat market-talk-cat-web hidden-sm hidden-xs"
        >
          <li>
            <a href="/market-talk"> Home </a>
          </li>
          <li>
            <a
              href="/market-talk/category/product-update/"
              class=""
              >PRODUCT UPDATE</a
            >
          </li>
          <li>
            <a href="/market-talk/category/news/" class=""
              >News</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/trading-101/"
              class=""
              >Trading 101</a
            >
          </li>
          <li>
            <a href="/market-talk/category/outlook/" class=""
              >Outlook</a
            >
          </li>
          <li>
            <a href="/market-talk/category/updates/" class=""
              >Updates</a
            >
          </li>
          <li>
            <a href="/market-talk/category/blogs/" class=""
              >Blogs</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/newsletters/"
              class=""
              >Newsletters</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/mutual-funds/"
              class=""
              >Mutual Funds</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/blogs/investing/"
              class=""
              >Investing</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/blogs/ipo/"
              class=""
              >IPO</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/blogs/nfo/"
              class=""
              >NFO</a
            >
          </li>
          <li>
            <a href="/market-talk/category/fo/" class=""
              >F&amp;O</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/quarterly-results/"
              class=""
              >Quarterly Results</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/newsletters/morning-update/"
              class=""
              >Morning Update</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/newsletters/market-recap/"
              class=""
              >Market Recap</a
            >
          </li>
          <li>
            <a href="/market-talk/category/the-list/" class=""
              >The List</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/union-budget-2023/"
              class=""
              >Union Budget 2023</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/investing-101/"
              class=""
              >Investing 101</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/blogs/sgb/"
              class=""
              >SGB</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/trending-stocks/"
              class=""
              >Trending stocks</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/share-market-videos/"
              class=""
              >Share Market Videos</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/live-news/"
              class=""
              >Live News</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/personal-finance/"
              class=""
              >Personal Finance</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/newsletters/weekly-wrap/"
              class=""
              >Weekly wrap</a
            >
          </li>
          <li>
            <a
              href="/market-talk/category/union-budget-2024/"
              class=""
              >Union Budget 2024</a
            >
          </li>
        </ul>
      </div>
    </section>

    <!-- dekstop category list -->

    <ul class="container market-talk-cat hidden-sm hidden-xs">
      <li class="search-cat-form">
        <div class="navbar-right">
          <form
            action="/market-talk/"
            class="search-form"
            role="search"
          >
            <div class="form-group pull-right" id="search">
              <input
                class="form-control"
                type="search"
                placeholder="Search articles &amp; blog..."
                name="s"
                value=""
                autocomplete="no"
              />
              <button
                type="submit"
                class="form-control form-control-submit button search"
              >
                Submit
              </button>
              <span class="search-label">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/blog/search-icon-blog.png"
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/blog/search-icon-blog@2x.png 2x
                  "
                />
              </span>
            </div>
          </form>
        </div>
      </li>
    </ul>
    <!-- mobile category list -->
    <div class="container mobile-cat-dropdown">
      <select name="event-dropdown" id="categories" class="hidden-md hidden-lg">
        <option value="allCategories">Select Category</option>
        <option value="/market-talk/category/product-update/">
          PRODUCT UPDATE
        </option>
        <option value="/market-talk/category/news/">
          News
        </option>
        <option value="/market-talk/category/trading-101/">
          Trading 101
        </option>
        <option value="/market-talk/category/outlook/">
          Outlook
        </option>
        <option value="/market-talk/category/updates/">
          Updates
        </option>
        <option value="/market-talk/category/blogs/">
          Blogs
        </option>
        <option value="/market-talk/category/newsletters/">
          Newsletters
        </option>
        <option value="/market-talk/category/mutual-funds/">
          Mutual Funds
        </option>
        <option
          value="/market-talk/category/blogs/investing/"
        >
          Investing
        </option>
        <option value="/market-talk/category/blogs/ipo/">
          IPO
        </option>
        <option value="/market-talk/category/blogs/nfo/">
          NFO
        </option>
        <option value="/market-talk/category/fo/">
          F&amp;O
        </option>
        <option
          value="/market-talk/category/quarterly-results/"
        >
          Quarterly Results
        </option>
        <option
          value="/market-talk/category/newsletters/morning-update/"
        >
          Morning Update
        </option>
        <option
          value="/market-talk/category/newsletters/market-recap/"
        >
          Market Recap
        </option>
        <option value="/market-talk/category/the-list/">
          The List
        </option>
        <option
          value="/market-talk/category/union-budget-2023/"
        >
          Union Budget 2023
        </option>
        <option value="/market-talk/category/investing-101/">
          Investing 101
        </option>
        <option value="/market-talk/category/blogs/sgb/">
          SGB
        </option>
        <option
          value="/market-talk/category/trending-stocks/"
        >
          Trending stocks
        </option>
        <option
          value="/market-talk/category/share-market-videos/"
        >
          Share Market Videos
        </option>
        <option value="/market-talk/category/live-news/">
          Live News
        </option>
        <option
          value="/market-talk/category/personal-finance/"
        >
          Personal Finance
        </option>
        <option
          value="/market-talk/category/newsletters/weekly-wrap/"
        >
          Weekly wrap
        </option>
        <option
          value="/market-talk/category/union-budget-2024/"
        >
          Union Budget 2024
        </option>
      </select>
    </div>

    <div class="trianle"></div>

    <section class="blog-posts blog-posts-wrapper">
      <div class="container !block">
        <div class="blog-posts">
          <div class="row">
            <article class="col-md-4">
              <div class="blog-img">
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-february-2025/"
                  class="read-more"
                >
                  <img
                    width="450"
                    height="265"
                    src="https://upstox.com/app/uploads/2025/02/image-6-450x265.png"
                    class="attachment-blog_thumb size-blog_thumb wp-post-image"
                    alt=""
                    loading="lazy"
                    srcset="
                      https://upstox.com/app/uploads/2025/02/image-6-450x265.png 450w,
                      https://upstox.com/app/uploads/2025/02/image-6-50x28.png    50w
                    "
                    sizes="(max-width: 450px) 100vw, 450px"
                  />
                </a>
              </div>
              <div class="blog-card">
                <div class="blog-post-date">PRODUCT UPDATE</div>
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-february-2025/"
                  class="post-content"
                >
                  <div class="post-info">
                    <h3>Tools to power your trades...</h3>
                    <div class="post-excerpt">
                      Roses are red, markets are green, and we’ve got upgrades
                      you’ve never seen! 🌹💹&nbsp; This...
                    </div>
                  </div>
                </a>
              </div>
            </article>

            <article class="col-md-4">
              <div class="blog-img">
                <a
                  href="/market-talk/january-updates-trade-from-charts-watchlist-tags-and-more/"
                  class="read-more"
                >
                  <img
                    width="450"
                    height="265"
                    src="https://upstox.com/app/uploads/2025/01/image-2-450x265.png"
                    class="attachment-blog_thumb size-blog_thumb wp-post-image"
                    alt=""
                    loading="lazy"
                    srcset="
                      https://upstox.com/app/uploads/2025/01/image-2-450x265.png 450w,
                      https://upstox.com/app/uploads/2025/01/image-2-50x28.png    50w
                    "
                    sizes="(max-width: 450px) 100vw, 450px"
                  />
                </a>
              </div>
              <div class="blog-card">
                <div class="blog-post-date">Morning Update</div>
                <a
                  href="/market-talk/january-updates-trade-from-charts-watchlist-tags-and-more/"
                  class="post-content"
                >
                  <div class="post-info">
                    <h3>January updates: Trade from charts,...</h3>
                    <div class="post-excerpt">
                      New Year, Newer Us! 🎉🚀 We’re starting off 2025 with
                      exciting updates to level up...
                    </div>
                  </div>
                </a>
              </div>
            </article>

            <article class="col-md-4">
              <div class="blog-img">
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-december-2024/"
                  class="read-more"
                >
                  <img
                    width="450"
                    height="265"
                    src="https://upstox.com/app/uploads/2024/12/image-60-450x265.png"
                    class="attachment-blog_thumb size-blog_thumb wp-post-image"
                    alt=""
                    loading="lazy"
                    srcset="
                      https://upstox.com/app/uploads/2024/12/image-60-450x265.png 450w,
                      https://upstox.com/app/uploads/2024/12/image-60-50x28.png    50w
                    "
                    sizes="(max-width: 450px) 100vw, 450px"
                  />
                </a>
              </div>
              <div class="blog-card">
                <div class="blog-post-date">PRODUCT UPDATE</div>
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-december-2024/"
                  class="post-content"
                >
                  <div class="post-info">
                    <h3>Tools to power your trades...</h3>
                    <div class="post-excerpt">
                      As 2024 comes to a close, we’re giving your trading
                      experience a final boost with...
                    </div>
                  </div>
                </a>
              </div>
            </article>

            <article class="col-md-4">
              <div class="blog-img">
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-november-2024/"
                  class="read-more"
                >
                  <img
                    width="450"
                    height="265"
                    src="https://upstox.com/app/uploads/2024/11/image-56-450x265.png"
                    class="attachment-blog_thumb size-blog_thumb wp-post-image"
                    alt=""
                    loading="lazy"
                    srcset="
                      https://upstox.com/app/uploads/2024/11/image-56-450x265.png 450w,
                      https://upstox.com/app/uploads/2024/11/image-56-50x28.png    50w
                    "
                    sizes="(max-width: 450px) 100vw, 450px"
                  />
                </a>
              </div>
              <div class="blog-card">
                <div class="blog-post-date">PRODUCT UPDATE</div>
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-november-2024/"
                  class="post-content"
                >
                  <div class="post-info">
                    <h3>Tools to power your trades...</h3>
                    <div class="post-excerpt">
                      November marks a milestone for us with our biggest product
                      launch yet! Explore the TBT...
                    </div>
                  </div>
                </a>
              </div>
            </article>

            <article class="col-md-4">
              <div class="blog-img">
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-october-2024/"
                  class="read-more"
                >
                  <img
                    width="450"
                    height="265"
                    src="https://upstox.com/app/uploads/2024/10/image-47-450x265.png"
                    class="attachment-blog_thumb size-blog_thumb wp-post-image"
                    alt=""
                    loading="lazy"
                  />
                </a>
              </div>
              <div class="blog-card">
                <div class="blog-post-date">PRODUCT UPDATE</div>
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-october-2024/"
                  class="post-content"
                >
                  <div class="post-info">
                    <h3>Tools to power your trades...</h3>
                    <div class="post-excerpt">
                      Just like Diwali movie releases, we’ve also got some
                      exciting product releases for you this...
                    </div>
                  </div>
                </a>
              </div>
            </article>

            <article class="col-md-4">
              <div class="blog-img">
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-july-2024/"
                  class="read-more"
                >
                  <img
                    width="450"
                    height="265"
                    src="https://upstox.com/app/uploads/2024/07/Thumbnail-9-450x265.png"
                    class="attachment-blog_thumb size-blog_thumb wp-post-image"
                    alt=""
                    loading="lazy"
                    srcset="
                      https://upstox.com/app/uploads/2024/07/Thumbnail-9-450x265.png 450w,
                      https://upstox.com/app/uploads/2024/07/Thumbnail-9-50x28.png    50w
                    "
                    sizes="(max-width: 450px) 100vw, 450px"
                  />
                </a>
              </div>
              <div class="blog-card">
                <div class="blog-post-date">PRODUCT UPDATE</div>
                <a
                  href="/market-talk/tools-to-power-your-trades-and-investments-july-2024/"
                  class="post-content"
                >
                  <div class="post-info">
                    <h3>Tools to power your trades...</h3>
                    <div class="post-excerpt">
                      With a refreshing monsoon lightening all of our moods, we
                      are here to share some...
                    </div>
                  </div>
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="blog-posts-wrapper1"></section>
    <div class="pagination vv hidden">
      <span aria-current="page" class="page-numbers current">1</span>
      <a class="page-numbers" href="/market-talk/page/2/"
        >2</a
      >
      <span class="page-numbers dots">…</span>
      <a class="page-numbers" href="/market-talk/page/12/"
        >12</a
      >
      <a class="next page-numbers" href="/market-talk/page/2/"
        >Next</a
      >
    </div>
  </div>
</template>
<style scoped>
</style>
